export default "__VITE_ASSET__CXNAME_7__"